import { render, staticRenderFns } from "./racas.vue?vue&type=template&id=68b8074b&"
import script from "./racas.vue?vue&type=script&lang=js&"
export * from "./racas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports